import { deleteQuote, updateQuote } from "../backend/db";
import { useState } from "react";

const QuoteCard = ({ id, author, content, userId, onCardClick }) => {
  const handleDelete = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDeleting(true);
    if (window.confirm("Are you sure you want to delete this quote?")) {
      try {
        await deleteQuote(userId, id);
        setIsDeleting(false);
      } catch (error) {
        console.log(error);
        setIsDeleting(false);
      }
    }
    setIsDeleting(false);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsUpdating(true);
    try {
      await updateQuote(userId, id, editAuthor, editContent);
      setIsUpdating(false);
      setIsEditing(false);
    } catch (error) {
      console.log(error);
      setIsUpdating(false);
    }
  };
  const closeUpdateForm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsEditing(false);
  };

  const [isDeleting, setIsDeleting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editContent, setEditContent] = useState("");
  const [editAuthor, setEditAuthor] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  return (
    <div
      onClick={onCardClick}
      className="w-full bg-card rounded-lg p-4  mb-6 transition duration-300 flex justify-between items-stretch border-solid border-2 border-sub hover_shadow "
    >
      <div>
        <h2 className="text-xl font-semibold mb-3">{content}</h2>
        <h3 className="text-gray-600">{author}</h3>
      </div>
      <div className="flex flex-col ml-4 h-full justify-between ">
        {/* Delete button */}
        <button
          onClick={handleDelete}
          className={`text-red-600 ml-4 h-full mb-5 ${
            isDeleting ? "cursor-not-allowed" : "hover:text-red-700"
          }`}
          disabled={isDeleting}
        >
          {isDeleting ? (
            "Deleting..."
          ) : (
            <span className="text-2xl">&times;</span>
          )}
        </button>

        {/* Edit button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setEditAuthor(author);
            setEditContent(content);
            setIsEditing(true); // open the edit form
          }}
          className="text-blue-600 hover:underline mt-auto"
        >
          Edit
        </button>
      </div>

      {isEditing && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="relative bg-card p-6 rounded-lg shadow-md w-96"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={closeUpdateForm}
              className="absolute top-2 right-2 text-red-600 text-2xl"
            >
              &times;
            </button>
            <form onSubmit={handleUpdate}>
              <h2 className="text-xl mb-4">Edit Quote</h2>
              <div>
                <label className="text-sm font-bold">Quote content</label>
                <textarea
                  type="text"
                  required
                  value={editContent}
                  onChange={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setEditContent(e.target.value);
                  }}
                  className="w-full mt-2 px-3 py-2 bg-transparent outline-none border border-gray-400 focus:border-sub shadow-sm rounded-lg transition duration-300"
                ></textarea>
              </div>
              <div className="mt-3">
                <label className="text-sm font-bold">Quote author</label>
                <input
                  type="text"
                  required
                  value={editAuthor}
                  onChange={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setEditAuthor(e.target.value);
                  }}
                  className="w-full mt-2 px-3 py-2 bg-transparent outline-none border border-gray-400 focus:border-sub shadow-sm rounded-lg transition duration-300"
                />
              </div>
              <button
                type="submit"
                disabled={isUpdating}
                className={`w-full mt-4 px-4 py-2 font-medium rounded-lg border-solid border-2 border-sub ${
                  isUpdating
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-deco hover:shadow-xl transition duration-300"
                }`}
              >
                {isUpdating ? "Updating..." : "Update"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuoteCard;
